import usePrivateAxios from "@/common/api/usePrivateAxios";
import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { TrackerIntegrationData, TrackerIntegrationResponse } from "../../types/trackerIntegration.type";

const useTrackerIntegration: (id: string) => UseQueryResult<TrackerIntegrationData, unknown> = (id) => {
  const privateAxios = usePrivateAxios()

  return useQuery<TrackerIntegrationResponse, unknown, TrackerIntegrationData>({
    queryKey: ['trackerIntegration', id],
    queryFn: () => privateAxios.get(`/client/tracker_integrations/${id}`),
    select: (data) => data?.data?.data
  });
};

export default useTrackerIntegration;
